import { takeLatest, call, put } from 'redux-saga/effects'
import {
  FETCH_CANDIDATES_DATA_REQUEST,
  UPDATE_CANDIDATES_DATA_SETTINGS,
  UPDATE_STATUS_BAR_CONTENT } from '../modules/actions'
import api from '../modules/api'

// worker saga: makes the api call when watcher saga sees the action
export function* candidatedsWorkerData() {
  try {
    const responseProposals = yield call(api.fetchCandidates)

    if (responseProposals.data.proposals) {
      let sortData = responseProposals.data.meta_data.sort_meta
      let sortPriority = ["proposal_open", "accepted", "offered"]
      let sortBy = sortPriority.find(e => sortData[e])
      let proposals = responseProposals.data.proposals
      const { graph_data, meta_data } = responseProposals.data
      const { first_accept } = responseProposals.data

      let newProposals = responseProposals.data.proposals.filter((proposal) =>  proposal.new_proposal === true)
      newProposals = newProposals.length
      let newPlans  = responseProposals.data.proposals.filter((proposal) => proposal.new_plan === true)

      newPlans = newPlans.length

      // if(newProposals !== 0) {
      //   yield put({
      //     type: TOGGLE_STATUS_BAR
      //   })
      // }

      yield put({
        type: UPDATE_CANDIDATES_DATA_SETTINGS,
        payload: {
          isLoading: false,
          proposals,
          graph_data,
          meta_data,
          first_accept,
          sortBy: sortBy
        }
      })

      let statusBarContent = []

      if (newProposals) {
        statusBarContent = [...statusBarContent, '新しい立候補が ' + newProposals + '件あります']
      }

      if (newPlans) {
        statusBarContent = [...statusBarContent, '新しいセカンドオピニオンレターが ' + newPlans + '件届きました']
      }

      yield put({
        type: UPDATE_STATUS_BAR_CONTENT,
        statusBarContent: statusBarContent,
        visibleStatusBar: statusBarContent.length ? true : false
      })
    }
  } catch (error) {
  }
}

export default [
  takeLatest(FETCH_CANDIDATES_DATA_REQUEST, candidatedsWorkerData)
]



// WEBPACK FOOTER //
// ./src/sagas/candidatesSagas.js